import api from "./api";

export async function listFornecedores(params) {
  const { data } = await api.get("/Fornecedores", { params });
  return data;
}

export async function getFornecedor(id) {
  const { data } = await api.get(`/Fornecedores/${id}`);
  return data;
}

export async function createFornecedor(payload) {
  const { data } = await api.post("/Fornecedores", payload);
  return data;
}

export async function updateFornecedor(id, payload) {
  await api.put(`/Fornecedores/${id}`, payload);
}

export async function deleteFornecedor(id) {
  await api.delete(`/Fornecedores/${id}`);
}

// Opções de Tipo — espelha TipoFornecedor do backend (Enums.cs). Value = int do enum.
export const TIPO_FORNECEDOR_OPTIONS = [
  { value: 0, label: "Hotel", icon: "🏨" },
  { value: 1, label: "Transporte", icon: "🚐" },
  { value: 2, label: "Restaurante", icon: "🍽️" },
  { value: 3, label: "Ingressos / Atrações", icon: "🎟️" },
  { value: 4, label: "Guia local", icon: "🗣️" },
  { value: 5, label: "Seguro", icon: "🛡️" },
  { value: 6, label: "Outro", icon: "📦" },
];

export function tipoFornecedorLabel(tipo) {
  return TIPO_FORNECEDOR_OPTIONS.find((t) => t.value === tipo)?.label ?? "—";
}

export function tipoFornecedorIcon(tipo) {
  return TIPO_FORNECEDOR_OPTIONS.find((t) => t.value === tipo)?.icon ?? "📦";
}
